export const DEFAULT_LOCATION_NAME = 'Main Location';

export const EMPTY_ADDRESS = {
  street1: '',
  street2: '',
  city: '',
  state: '',
  stateLabel: '',
  zipCode: '',
  fullAddress: '',
};

export const buildFullAddress = (address = {}) => {
  const street1 = String(address.street1 || '').trim();
  const street2 = String(address.street2 || '').trim();
  const city = String(address.city || '').trim();
  const state = String(address.state || '').trim();
  const zipCode = String(address.zipCode || '').trim();

  if (!street1 && !city) {
    return '';
  }

  const streetLine = street2 ? `${street1}, ${street2}` : street1;
  return [streetLine, city, state, zipCode].filter(Boolean).join(', ');
};

export const normalizeLocationAddress = (address = {}) => {
  const normalized = {
    street1: String(address.street1 || '').trim(),
    street2: String(address.street2 || '').trim(),
    city: String(address.city || '').trim(),
    state: String(address.state || '').trim(),
    stateLabel: String(address.stateLabel || '').trim(),
    zipCode: String(address.zipCode || '').trim(),
    fullAddress: String(address.fullAddress || '').trim(),
  };

  if (!normalized.fullAddress) {
    normalized.fullAddress = buildFullAddress(normalized);
  }

  return normalized;
};

export const normalizeLocationIds = (ids) => {
  if (!Array.isArray(ids)) return [];
  return Array.from(
    new Set(
      ids
        .map((id) => String(id || '').trim())
        .filter(Boolean)
    )
  );
};

export const entityAssignedToLocation = (entity = {}, locationId) => {
  const normalizedLocationId = String(locationId || '').trim();
  if (!normalizedLocationId) return true;

  const locationIds = normalizeLocationIds(entity.locationIds);
  if (locationIds.length === 0) return true;
  return locationIds.includes(normalizedLocationId);
};
